///
/// EarthBrowser
///
/// Migration v12 to v13: Add minimized window tile positions
///
/// Created by Matt Giger on December 20, 2025
/// Copyright (c) 2025 Geodata Labs
///

interface StateV12 {
	userInterface?: Record<string, unknown>
}

/**
 * Migration from version 12 to 13: Add minimized tile position persistence
 * - Adds minimizedTilePositions field to userInterface slice (empty object)
 * - Replaces the old centered dock with individual draggable tiles
 * - Each tile can be positioned independently and snapped to screen edges
 * - Positions are persisted across launch sessions
 */
export function migrateV12toV13(state: unknown): unknown {
	if (!state) {
		return state
	}

	const s = state as StateV12

	// Return new state with minimizedTilePositions added
	return {
		...s,
		userInterface: {
			...s.userInterface,
			minimizedTilePositions: {}
		}
	}
}
